import { Translate } from 'react-redux-i18n'
import { Element } from '../../html/element'

export const GroupContentFilter = ({
  data,
  title,
  isAll,
  renderWhenStatusAll,
}) => {
  const dataLabel = data.map((item) => item.label)

  if (dataLabel.length === 0) return <></>
  return (
    <Element
      className="dFlex gap5"
      style={{
        backgroundColor: '#F3F3F3',
        padding: '8px 12px',
      }}
    >
      <Element
        elementName="span"
        className="fw600 "
        style={{
          width: 120,
        }}
      >
        <Translate value={title} />
      </Element>
      <div className="flex1">
        {isAll ? (
          <>{renderWhenStatusAll && renderWhenStatusAll()}</>
        ) : (
          <>
            {dataLabel.map((item, index) => (
              <Element
                key={index}
                elementName="span"
                style={{
                  wordBreak: 'break-all',
                }}
              >
                {index === 0 ? '' : ',  '} {item}
              </Element>
            ))}
          </>
        )}
      </div>
    </Element>
  )
}
